import React, { useState, useMemo } from "react";
import { Pagination as RBPagination } from "react-bootstrap";
import { toPersianNum } from "utils/helpers";
import { PaginationProps } from "./Pagination.props";
import "./style.scss";

const Pagination = React.memo<PaginationProps>(
    ({ totalCount, currentPage = 1, pageSize = 30, onPageChange }) => {
        const [selectedPage, setSelectedPage] = useState(currentPage);
        const totalPageCount = Math.ceil(totalCount / pageSize);

        const range = (start: number, end: number) => {
            var list = [];
            for (let i = start; i <= end; i++) {
                list.push(i);
            }
            return list;
        };

        const paginationRange = useMemo(() => {
            const totalVisiblePageNumbers = 7;
            const maxPageNumbersBeforDot = 4;
            const maxPageNumbersAfterDot = 4;

            if (totalPageCount < totalVisiblePageNumbers) {
                return range(1, totalPageCount);
            } else {
                if (selectedPage <= maxPageNumbersBeforDot) {
                    let rightPart = range(1, maxPageNumbersBeforDot + 1);
                    return [...rightPart, "dots", totalPageCount];
                }
                if (
                    selectedPage > maxPageNumbersBeforDot &&
                    selectedPage <= totalPageCount - maxPageNumbersBeforDot
                ) {
                    let rightPart = [1, "dots", selectedPage - 1, selectedPage];
                    let leftPart = [selectedPage + 1, "dots", totalPageCount];
                    return [...rightPart, ...leftPart];
                } else {
                    let rightPart = [1, "dots"];
                    let leftPart = range(
                        totalPageCount - maxPageNumbersAfterDot,
                        totalPageCount
                    );
                    return [...rightPart, ...leftPart];
                }
            }
        }, [totalPageCount, selectedPage]);

        const onChangeCurrentPage = (value: number) => {
            setSelectedPage(value);
            onPageChange(value);
        };

        let items = [];

        for (let key in paginationRange) {
            if (typeof paginationRange[key] === "number") {
                items.push(
                    <RBPagination.Item
                        data-testid="page-item"
                        key={key}
                        active={paginationRange[key] === selectedPage}
                        onClick={() =>
                            onChangeCurrentPage(+paginationRange[key])
                        }
                    >
                        {toPersianNum(paginationRange[key])}
                    </RBPagination.Item>
                );
            } else {
                items.push(<RBPagination.Ellipsis key={key} />);
            }
        }

        return (
            <>
                {items.length > 1 && (
                    <div
                        className="pagination-container"
                        data-testid="pagination-container"
                    >
                        <RBPagination>
                            <RBPagination.Prev
                                data-testid="prev-arrow-btn"
                                onClick={() =>
                                    onChangeCurrentPage(selectedPage - 1)
                                }
                                disabled={selectedPage === 1}
                            />
                            {items}
                            <RBPagination.Next
                                data-testid="next-arrow-btn"
                                onClick={() =>
                                    onChangeCurrentPage(selectedPage + 1)
                                }
                                disabled={selectedPage === totalPageCount}
                            />
                        </RBPagination>
                    </div>
                )}
            </>
        );
    }
);

export default Pagination;
